import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { globalBus } from './streams/wsBus';
import { openInContextCanvas, closeContextCanvas } from './studio/canvas';

// Expose canvas functions globally for testing ABDA Phase 1B DoD
// This allows triggering Context Canvas from browser console with:
// window.openInContextCanvas({ type: 'browser', url: 'https://github.com/...', title: 'PR' })
if (typeof window !== 'undefined') {
    (window as any).openInContextCanvas = openInContextCanvas;
    (window as any).closeContextCanvas = closeContextCanvas;
}

// Build timestamp to force fresh Netlify build: 2026-01-09T18:16:00Z
const BUILD_TIMESTAMP = '2026-01-09T18:16:00Z';

if (typeof window !== 'undefined' && typeof (window as any).process === 'undefined') {
    (window as any).process = { env: {} };
}

// Global error handlers to catch errors outside React's ErrorBoundary
// These catch module init failures, async promise rejections, and dynamic import failures
if (typeof window !== 'undefined') {
    window.addEventListener('error', event => {
        console.error('[GlobalErrorHandler] Uncaught error:', {
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            error: event.error,
            stack: event.error?.stack,
            route: window.location.pathname,
            timestamp: new Date().toISOString(),
        });
    });

    window.addEventListener('unhandledrejection', event => {
        console.error('[GlobalErrorHandler] Unhandled promise rejection:', {
            reason: event.reason,
            message: event.reason?.message,
            stack: event.reason?.stack,
            route: window.location.pathname,
            timestamp: new Date().toISOString(),
        });
    });

    console.log('[GlobalErrorHandler] Error handlers installed');
}

// globalBus.connect();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);

// Unregister any existing service workers to ensure fresh bundles are served
// This is a one-time cleanup to fix caching issues with Matrix V2 Phase E
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => {
            reg.unregister();
            console.log('Service Worker unregistered:', reg.scope);
        });
    });
}

// Service Worker registration disabled for now to prevent caching issues
// Re-enable with proper cache-busting strategy in Phase F or later
// if (import.meta.env.VITE_ENABLE_SW === 'true' && 'serviceWorker' in navigator && 'PushManager' in window) {
//     navigator.serviceWorker
//         .register('/sw.js')
//         .then(registration => {
//             console.log('Service Worker registered', registration);
//         })
//         .catch(error => {
//             console.error('Service Worker registration failed:', error);
//         });
// }
